import { render } from "./Tabela.vue?vue&type=template&id=8317b422&ts=true"
import script from "./Tabela.vue?vue&type=script&lang=ts"
export * from "./Tabela.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Tabela/Tabela.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8317b422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8317b422', __exports__)) {
    api.reload('8317b422', __exports__)
  }
  
  module.hot.accept("./Tabela.vue?vue&type=template&id=8317b422&ts=true", () => {
    api.rerender('8317b422', render)
  })

}


export default __exports__